<template>
  <div class="tw-w-full">
    <div
      class="tw-border-[1px] tw-border-solid tw-bg-white tw-rounded-lg tw-flex tw-items-center tw-gap-3 tw-px-4 tw-w-full"
      :class="[disabledClass, focusClass, errorClass, borderClass, customClass]"
    >
      <slot name="prepend"></slot>
      <div class="tw-w-full">
        <input
          ref="inputRef"
          :value="value"
          :type="type"
          :placeholder="placeholder"
          :disabled="disabled"
          class="tw-bg-transparent tw-border-none tw-w-full tw-outline-none"
          :class="[
            sizeClass,
            {
              'tw-text-sm tw-leading-5': size !== 'large',
            },
          ]"
          @focus="onFocus"
          @blur="onBlur"
          @input="onInput"
          @keyup.enter="$emit('enter')"
        />
      </div>
      <slot name="append"></slot>
    </div>
    <div
      v-if="error"
      class="tw-text-xs tw-leading-5 tw-pt-1 tw-pl-3 tw-text-red-700"
      :class="[errorPosition]"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'medium',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: 'text',
    },

    placeholder: {
      type: String,
      default: '',
    },

    error: {
      type: Boolean,
      default: false,
    },

    errorMessage: {
      type: String,
      default: 'Required',
    },

    value: {
      type: [String, Number],
      default: '',
    },

    borderClass: {
      type: String,
      default: 'tw-border-gray-400',
    },

    numberOnly: {
      type: Boolean,
      default: false,
    },

    errorPosition: {
      type: String,
      default: '',
    },

    customClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isFocus: false,
    };
  },

  computed: {
    sizeClass() {
      const medium = this.size === 'large' ? '' : 'tw-text-sm tw-leading-5';
      let spacing = 'tw-py-2.5 tw-h-[40px]';
      switch (this.size) {
        case 'small':
          spacing = 'tw-py-1.5 tw-h-[34px]';
          break;
        case 'large':
          spacing = 'tw-py-2.5 tw-h-[48px]';
          break;
        default:
          spacing = 'tw-py-2.5 tw-h-[44px]';
          break;
      }

      return `${medium} ${spacing}`;
    },

    disabledClass() {
      return this.disabled ? 'tw-opacity-50' : '';
    },

    focusClass() {
      return this.isFocus ? '!tw-border-purple-600' : '';
    },

    errorClass() {
      return this.error ? '!tw-border-red-700' : '';
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (this.numberOnly && parseInt(String(v), 10) < 0) {
          this.$emit('input', 0);
        }
      },
    },
  },

  methods: {
    onFocus() {
      this.isFocus = true;
      this.$refs.inputRef.focus();
      this.$emit('focus');
    },

    onBlur() {
      this.isFocus = false;
      this.$emit('blur');
    },

    onInput(event) {
      let value = event.target.value;
      if (
        this.numberOnly &&
        (event?.data?.includes('-') || event?.data?.includes('+'))
      ) {
        value = 0;
      }
      this.$emit('input', value);
    },
  },
};
</script>
